import { Grid } from '@mui/material';

const AccordionList = ({ accordions = [], children }) => {
  const gridContainerStyle = { flexDirection: 'column' };
  const gridItemStyle = { width: '100%' };

  const components = children && Array.isArray(children) ? children : accordions;

  const renderAccordions = (accordions = []) =>
    accordions.map((accordion, index) => {
      return (
        <Grid key={index} item sx={gridItemStyle}>
          {accordion}
        </Grid>
      );
    });

  return (
    <Grid container spacing={3} sx={gridContainerStyle}>
      {renderAccordions(components)}
    </Grid>
  );
};

export default AccordionList;
